import { render, staticRenderFns } from "./ChangeAdminUserPasswordDialog.vue?vue&type=template&id=74b6fd7b&"
import script from "./ChangeAdminUserPasswordDialog.vue?vue&type=script&lang=js&"
export * from "./ChangeAdminUserPasswordDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports